import React, { useEffect, useState, JSX } from 'react';
import { Form } from 'react-bootstrap';
import Cookies from 'js-cookie';
import Styles from './UserLoggedPricesToggle.module.scss';
import { trackNewDatalayerEvent } from '../../utils/AnalyticsUtils';
import { NEW, DISABLE, HIDE } from '../../utils/constants';
import { GAEVENT, TOGGLECLICK } from '../../Analytics/AnalyticsConstants';
interface UserLoggedPricesToggleProps {
  content: any;
  index: number;
  lineTable: boolean;
  toggleContent?: any;
}
const UserLoggedPricesToggle = ({
  content,
  index,
  lineTable,
  toggleContent
}: UserLoggedPricesToggleProps): JSX.Element => {
  const [toggleState, setToggleState] = useState<boolean>(false);
  const [enable, setEnable] = useState<boolean>(false);
  const [isEligible, setIsEligible] = useState(false);
  const [hideToggleLoggedIn, setHideToggleLoggedIn] = useState<boolean>(false);
  const [disableToggleLoggedIn, setDisableToggleLoggedIn] = useState<boolean>(false);
  const isLineTable = lineTable;

  let authData:any = null;
  try {
    const cookie = Cookies.get('sunriseAuth');
    authData = cookie ? JSON.parse(cookie) : null;
  } catch (e) {
    console.error('Invalid sunriseAuth cookie:', e);
  }
  
 useEffect(() => {
  if (typeof window === 'undefined') return;

  

  const isNewCustomer = toggleContent.customers.toLowerCase() === NEW;
  const toggleEnabled = isNewCustomer
    ? toggleContent.newUserToggleEnabled
    : toggleContent.loggedUserToggleEnabled; 

  const stored = toggleContent.enableLoggedInPrice ? localStorage.getItem('userLoggedPricesToggle') : null;
  const isStoredTrue = stored === 'true';
  const isStoredNull = stored === null;

  if (isStoredTrue || (isStoredNull && toggleEnabled)) {
    setToggleState(true)
  }
 }, [toggleContent]);
  
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const handleGlobalToggle = (e: any) => {
      const delay = index * 0;
      setTimeout(() => {
        setToggleState(e.detail.value);
        localStorage.setItem('userLoggedPricesToggle', JSON.stringify(e.detail.value));
      }, delay);
    };
    window.addEventListener('user-logged-prices-toggle-all', handleGlobalToggle);
    return () => {
      window.removeEventListener('user-logged-prices-toggle-all', handleGlobalToggle);
    };
  }, [index]);
  
  useEffect(() => {
    if ( !isLineTable ) {
      setEnable(true);
    }
  }, [isLineTable]);

  useEffect(() => {
    if (!authData) return;

    const isNewCustomer = toggleContent.customers.toLowerCase() === NEW;
    const newHide = isNewCustomer && toggleContent.loggedUserAction.toLowerCase() === HIDE;
    const newDisable = isNewCustomer && toggleContent.loggedUserAction.toLowerCase() === DISABLE;
    setHideToggleLoggedIn(prev => (prev !== newHide ? newHide : prev));
    setDisableToggleLoggedIn(prev => (prev !== newDisable ? newDisable : prev));
  }, [authData, toggleContent]);
  
  useEffect(() => {
    if ( content && !content?.extraBenefits) {
      const eligible = Array.isArray(content?.benefits) &&
        content.benefits.some((benefit: any) =>
          ['multimob_fmc', 'int_fmc'].includes(benefit.id)
        );
      setIsEligible(eligible);
    }   
  }, [content]);
  
  useEffect(() => {
      if(isEligible) {
        setEnable(isEligible);
      }
  }, [isEligible]);
  
  const handleToggleChange = () => {
    const newValue = !toggleState;
    window.dispatchEvent(
      new CustomEvent('user-logged-prices-toggle-all', {
        detail: { value: newValue },
      })
    );
    trackNewDatalayerEvent(GAEVENT, TOGGLECLICK, {
      headline: `${content.productId ? content.productId : content.pageType} | ${toggleContent?.togglePosition}`,
      selection: newValue,
    });
  };
  
  return (content && !hideToggleLoggedIn) ? (
    <div
      className={`${Styles.loggedPriceToggle} ${
        lineTable ? Styles['multiple'] : Styles['unique']
      }`}
    >
      {enable && (
        <Form>
          <Form.Check
            type="switch"
            checked={toggleState}
            onChange={handleToggleChange}
            label={toggleContent?.toggleLabel }
            disabled={disableToggleLoggedIn}
          />
          {!isLineTable && (
            <p className={`${disableToggleLoggedIn ? Styles['disabled'] : ''}`}>
              {toggleContent?.toggleDescription}
            </p>
          )}
        </Form>
       )} 
    </div>
  ) : (
    <></>
  );
};
export default UserLoggedPricesToggle;